import {
  faClockRotateLeft,
  faFileWaveform,
  faScreenUsers,
  faNotebook,
} from '@fortawesome/pro-light-svg-icons';

export const PageDetails = {
  ats: {
    id: 'ats',
    title: 'ATS',
    url: 'ats',
  },
  courses: {
    id: 'courses',
    page: 'courses',
    title: 'Manage Courses',
    url: 'ats/courses',
    icon: faScreenUsers,
    description: 'See current and next semester courses with details for codec, CRN, subject etc.',
  },
  codecs: {
    id: 'codecs',
    page: 'codecs',
    title: 'Manage Codecs',
    url: 'codecs',
    icon: faFileWaveform,
    description: 'Edit, delete, add or upload CSV for codecs.',
  },
  actionHistory: {
    id: 'actionHistory',
    page: 'actionHistory',
    title: 'Action History',
    url: 'actionHistory',
    icon: faClockRotateLeft,
    description: 'Search/view actions by description, title, status or admin MIDAS.',
  },
  courseDetails: {
    id: 'courseDetails',
    page: 'courseDetails',
    title: 'Course Details',
    url: 'courseDetails',
    isHide: true,
    icon: faNotebook,
    description: 'Some description here.',
  },
};
